module.exports = __webpack_public_path__ + "static/media/check_inactive.5ce79e99.svg";